export const ROUTES = {
  home: '/',
  about: '/about',
  privacy: '/privacy',
  terms: '/terms',
  dmca: '/dmca',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
  history: '/dashboard/history',
  files: '/dashboard/files',
  settings: '/dashboard/settings',
  admin: '/dashboard/admin',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
